import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../contexts';
import ListSubMerchant from './ListSubMerchant';
import styles from './styles.scoped.css';

export default function SettingHarga() {
  const { setBreadcrumbs } = useContext(AppContext);


  useEffect(() => {
    setBreadcrumbs(['Aktivasi Fitur Pendaftaran Subpangkalan']);
  }, []);

  return (
    <div className={styles.root}>
      <ListSubMerchant />
    </div>
  );
}
